/** Lo que viaja entre el servidor y las bases de datos del espacio de trabajo. */

export type TipoProp =
  | 'text' | 'number' | 'select' | 'multi_select' | 'status' | 'date' | 'checkbox' | 'url' | 'person'

export type TipoVista = 'table' | 'board' | 'gallery' | 'calendar'

export interface Opcion {
  id: string
  name: string
  color: string
}

export interface Propiedad {
  id: string
  name: string
  type: TipoProp
  options?: Opcion[]
}

export interface Filtro {
  prop: string
  op: string
  value: string | number | boolean | null
}

export interface Vista {
  id: string
  name: string
  type: TipoVista
  group_by?: string
  date_by?: string
  sort?: { prop: string; dir: 'asc' | 'desc' }
  filters?: Filtro[]
  hidden?: string[]
  widths?: Record<string, number>
}

export interface Esquema {
  properties: Propiedad[]
  views: Vista[]
}

export interface Fila {
  id: number
  title: string
  icon: string | null
  position: number
  props: Record<string, unknown>
  created_at: string
  updated_at: string
  resumen: string
}

export interface FechaValor {
  start: string
  end?: string
}

/** Cómo se llama cada tipo y qué símbolo lo representa en los menús. */
export const TIPOS: { tipo: TipoProp; nombre: string; icono: string }[] = [
  { tipo: 'text', nombre: 'Texto', icono: 'Aa' },
  { tipo: 'number', nombre: 'Número', icono: '#' },
  { tipo: 'select', nombre: 'Selección', icono: '◉' },
  { tipo: 'multi_select', nombre: 'Selección múltiple', icono: '☰' },
  { tipo: 'status', nombre: 'Estado', icono: '◐' },
  { tipo: 'date', nombre: 'Fecha', icono: '▦' },
  { tipo: 'checkbox', nombre: 'Casilla', icono: '☑' },
  { tipo: 'url', nombre: 'Enlace', icono: '↗' },
  { tipo: 'person', nombre: 'Persona', icono: '☺' },
]

export const ICONO_DE_TIPO: Record<TipoProp, string> = Object.fromEntries(
  TIPOS.map((t) => [t.tipo, t.icono]),
) as Record<TipoProp, string>

export const COLORES = [
  'gris', 'marron', 'naranja', 'amarillo', 'verde', 'azul', 'morado', 'rosa', 'rojo',
] as const

export const VISTAS: { tipo: TipoVista; nombre: string; icono: string }[] = [
  { tipo: 'table', nombre: 'Tabla', icono: '▦' },
  { tipo: 'board', nombre: 'Tablero', icono: '▥' },
  { tipo: 'gallery', nombre: 'Galería', icono: '▤' },
  { tipo: 'calendar', nombre: 'Calendario', icono: '▧' },
]
